/* global axios */
import ApiClient from '../ApiClient';

// BonBoZ: chủ đề của mẫu trả lời (tên + màu). Danh sách dùng chung cấp tài
// khoản — xem `app/models/bonboz/chu_de_mau.rb`.
class ChuDeMauAPI extends ApiClient {
  constructor() {
    super('bonboz/chu_de_maus', { accountScoped: true });
  }

  taoMoi({ ten, mau }) {
    return axios.post(this.url, { chu_de: { ten, mau } });
  }

  sua(id, { ten, mau }) {
    return axios.patch(`${this.url}/${id}`, { chu_de: { ten, mau } });
  }

  xoa(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ChuDeMauAPI();
